export default __webpack_public_path__ + "static/media/blog-39-6.0a61a974.png";